export default {
  "header": "WHAT AWESOME PARENTS (LIKE YOU!) ARE SAYING",
  "quotes": [
    {
      quote: "“These are real clothes to LIVE and PLAY in! My son is full of personality and wears Rockets of Awesome to reflect that.”",
      signature: "Andrea — Dallas TX"
    },
    {
      quote: "“My spunky daughter loves to be an original and love that we've found a brand that can help her define her unique sense of self!”",
      signature: "Maddie — Cincinnati OH"
    },
    {
      quote: "“My son loves your stuff more than any of his other clothes, and digs through his drawers to find them! I’m not sure if it’s the super-softness or the graphics, but thank you!”",
      signature: "Courtney — Philadelphia PA"
    },
    {
      quote: "“It’s great to see my kids feel so confident that what they’re wearing expresses who they are as individuals.”",
      signature: "Robin — Brooklyn NY"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/customerQuotes/defaultProps.js